import { LoadMoreButton } from "@rio-cloud/rio-uikit";
import { useEffect, useState } from "react";

const initialState = { loaded: 1, total: 0 };

interface Props {
  pages: number;
  page: number;
  handlePage: (params: { page: number, pages?: number }) => void;
  pagesPerBlock?: number;
  pageSize: number;
  hiddenReset?: boolean;
  disabled: boolean;
}

const Paginator = ({ pages, page, handlePage, pageSize, hiddenReset = true, disabled = false }: Props) => {
  const [state, setState] = useState<any>(initialState);


  useEffect(() => {
    if (disabled) return;

    if (!pages) return;

    let totalPages = Math.ceil(pages);
    totalPages = page == 0 ? totalPages : totalPages;
    page = page == 0 ? 1 : page;
    setState({
      total: totalPages,
      loaded: page == 0 ? 1 : page,
    });

  }, [pages, page]);

  const handleReset = () => {
    try {
      const newLoaded = {
        ...state,
        loaded: 1,
      }
      setState(newLoaded);
      handlePage({ page: 0, pages: newLoaded.total });
    } catch (error) {
    } finally {
    }
  };

  const handleLoadMore = () => {
    try {
      const { loaded, total } = state;
      const newLoaded = {
        ...state,
        loaded: loaded + 1,
      }
      if (newLoaded.loaded <= total) {
        setState(newLoaded);
        handlePage({ page: newLoaded.loaded, pages: newLoaded.total });
      }

    } catch (error) {
    } finally {

    }
  };

  if (disabled) {
    return (
      <div className={`display-flex justify-content-center align-items-center width-100pct`} >
      </div>
    );
  }

  return (
    <div className={`display-flex justify-content-center align-items-center width-100pct`} >
      <LoadMoreButton loaded={state.loaded} total={state.total}
        loadMoreMessage={
          <div className='display-flex flex-row gap-10'>
            {hiddenReset ? null : (
              <button className='btn btn-default' type='button' onClick={handleReset}>
                Resetar
              </button>
            )}
            <button className='btn btn-default btn-primary' type='button' onClick={handleLoadMore}>
              Carregar mais
            </button>
          </div>
        }
        noMoreMessage={
          <div className='display-flex flex-column justify-content-center align-items-center'>
            {state.total > 1 && !hiddenReset ? (
              <div className='flex flex-row align-items-center justify-content-center margin-bottom-10'>
                <button className='btn btn-default flex-row' type='button' onClick={handleReset}>
                  Resetar
                </button>
              </div>
            ) : null}
            <div className='flex flex-row'>
              <span>Não há mais resultados</span>
            </div>
          </div>
        }
        progressBarStyle='gray'
        isInteractive={false}
      />
    </div>
  );
};

export default Paginator;
